var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.893283e02653bce7fc83611286c3532e.svg#v';
                    var viewUrl = 'sprites.893283e02653bce7fc83611286c3532e.svg#view-v';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 10 11',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };